import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Title } from './Home.style'
import { useGetUser } from '@hooks/useAuth'
import HomeTabs from './components/HomeTabs/HomeTabs.component'
import CarpaySection from './components/CarpaySection/CarpaySection.component'
import BookingSection from './components/BookingSection/BookingSection.component'
import { Card, CardIcon, CardText } from './components/sections.style'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { searchRoute } from '@views/Search/route'
import { lotBaseRoute, lotRoute } from '@views/Lot/route'
import PastOrdersContainer from './components/PastOrders/PastOrdersContainer.component'
import { SeoHead } from '@components/SeoHead/SeoHead.component'
import { getLanguageBasedOnDomain } from '@utils/getDomainExtension'

const Home = () => {
    const { t, i18n } = useTranslation()
    const seoLang = i18n.getFixedT(getLanguageBasedOnDomain())
    const history = useHistory()
    const { user } = useGetUser()
    const [selectedTab, setSelectedTab] = useState(0)
    const { search, pathname } = useLocation()
    const queryParams = new URLSearchParams(search)

    const isLotRoute = matchPath<{ lotId: string }>(pathname, { path: lotBaseRoute() })
    const lotId = isLotRoute?.isExact ? isLotRoute.params.lotId : queryParams.get('lot_id')

    const onReservationClick = () => {
        if (lotId) {
            history.push(lotRoute(lotId))
            return
        }

        history.push(searchRoute())
    }

    return (
        <>
            <SeoHead title={seoLang('seo.pages.homeTitle')} description={seoLang('seo.pages.homeDescription')} />
            <Container>
                <Title>{user ? `Hey ${user.first_name}` : t('home.title')}</Title>
                {user && <HomeTabs activeTab={selectedTab} onTabChange={(tab) => setSelectedTab(tab)} />}

                {selectedTab === 0 ? (
                    <>
                        <CarpaySection />

                        <div>
                            {user && <BookingSection />}
                            <Card $isLast={false} onClick={onReservationClick}>
                                <CardIcon className="wemolo-plus" aria-hidden="true" />
                                <CardText>{t('home.reservationOrTenant')}</CardText>
                            </Card>
                        </div>
                    </>
                ) : (
                    <PastOrdersContainer />
                )}
            </Container>
        </>
    )
}

export default Home
